// Jeden i ten sam URL dla wszystkich środowisk - plik whats-new.json hostowany na CDN
// (źródło prawdy w split-zero-api/release-notes/, publikowany przez CD). Patrz ADR-0013.
export const WhatsNewUrl: string = 'https://cdn.split-zero.com/whats-new/whats-new.json';
